import PropTypes from "prop-types"
import { chain } from "lodash"
import { Paper } from "@mui/material"
import Table from "components/material/table"
import ExcelDownload from "components/excel-download"
import columns from "./columns"

export default function AttributeCoverageReport({ portfolioAlias, rows, rowsPerPage, uploadDate }) {
  const fileName = `${portfolioAlias} - Attribute category coverage - ${uploadDate}`

  const data = [
    ["Attr. Category", "Date (YYYY-MM-DD)", "With Attr. %", "No attr. equities %", "No attr. securities"],
    ...chain(rows)
      .sortBy(["attributeCategory", "date"])
      .map(({ attributeCategory, formattedDate, percentWithAttributes, percentNoAttributeEquities, noAttributeSecurities }) => ([attributeCategory, formattedDate, percentWithAttributes, percentNoAttributeEquities, noAttributeSecurities]))
      .values(),
  ]

  return <Paper square elevation={1} className="attribute-coverage-report">
    <Table
      title="Attribute category coverage breakdown"
      idField="id"
      columns={columns}
      data={rows}
      addForm={false}
      pagination
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[]}
      actions={[<ExcelDownload key="excel-download" data={data} fileName={fileName} />]}
    />
  </Paper>
}

AttributeCoverageReport.propTypes = {
  portfolioAlias: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  rowsPerPage: PropTypes.number,
  uploadDate: PropTypes.string.isRequired,
}
